import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=b543c8c2&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=b543c8c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b543c8c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b543c8c2')) {
      api.createRecord('b543c8c2', component.options)
    } else {
      api.reload('b543c8c2', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=b543c8c2&scoped=true", function () {
      api.rerender('b543c8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/user/UserForm.vue"
export default component.exports